/* tslint:disable */
/* eslint-disable */
/**
 * Zalaris Benchmarks Benchmark API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * AI configuration used for generation
 */
export interface AIConfigData {
    /**
     * AI provider (e.g., OPENAI, AZURE_OPENAI)
     */
    'provider': string;
    /**
     * AI model used
     */
    'model': string;
    /**
     * Temperature parameter (null if not set)
     */
    'temperature'?: number | null;
    /**
     * Top-p parameter (null if not set)
     */
    'topP'?: number | null;
    /**
     * Maximum tokens parameter (null if not set)
     */
    'maxTokens'?: number | null;
}
/**
 * Error envelope for AI-related failures (extends ErrorResponse)
 */
export interface AIError {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
    /**
     * Sanitized prompt that was sent to the AI
     */
    'prompt'?: string;
    /**
     * Raw AI response body for debugging
     */
    'raw_response'?: string;
    /**
     * Parse or validation error details
     */
    'details'?: string;
}
/**
 * AI response data
 */
export interface AIResponseData {
    /**
     * Raw JSON response from AI
     */
    'rawResponse'?: string;
    /**
     * Whether the response was successfully parsed
     */
    'parsedSuccessfully': boolean;
    /**
     * Response time in milliseconds
     */
    'responseTimeMs': number;
}
/**
 * Base schema for AI-specific context parameters. This schema is reused across enrichment and generation contexts to allow overriding default AI prompt and provider selection.  Used in: - Position enrichment: PositionEnrichmentContext.ai - Benchmark generation: BenchmarkGenerationRequest.ai 
 */
export interface AiContextBase {
    /**
     * Specific AI prompt ID to use (overrides default)
     */
    'promptId'?: string;
    'provider'?: AiProvider;
}


/**
 * AI-specific context for benchmark generation. Allows overriding default AI prompt and provider selection during generation. 
 */
export interface AiGenerationContext {
    /**
     * Specific AI prompt ID to use (overrides default)
     */
    'promptId'?: string;
    'provider'?: AiProvider;
}



export const AiProvider = {
    Openai: 'openai',
    AzureOpenai: 'azure-openai'
} as const;

export type AiProvider = typeof AiProvider[keyof typeof AiProvider];


export interface Benchmark {
    'id': string;
    /**
     * Reference to the position
     */
    'positionId': string;
    /**
     * Position code for reference
     */
    'positionCode': string;
    /**
     * Job classification code
     */
    'jobCode'?: string;
    /**
     * Minimum market rate
     */
    'marketRateMin'?: number;
    /**
     * Median market rate
     */
    'marketRateMedian'?: number;
    /**
     * Maximum market rate
     */
    'marketRateMax'?: number;
    /**
     * 25th percentile market rate
     */
    'marketRatePercentile25'?: number;
    /**
     * 75th percentile market rate
     */
    'marketRatePercentile75'?: number;
    /**
     * Currency code (e.g., USD, EUR, NOK)
     */
    'currency'?: string;
    /**
     * When the benchmark was created
     */
    'createdAtDate'?: string;
    /**
     * User who created the benchmark
     */
    'createdBy'?: string;
    /**
     * When the benchmark was uploaded to successFactors
     */
    'uploadedAt'?: string;
    /**
     * User who uploaded the benchmark to SuccessFactors
     */
    'uploadedBy'?: string;
}
/**
 * Audit log entry for a benchmark generation attempt
 */
export interface BenchmarkGenerationLog {
    /**
     * Unique identifier of the log entry
     */
    'id': string;
    /**
     * ID of the generated benchmark (null if generation failed)
     */
    'benchmarkId'?: string | null;
    /**
     * ID of the position for which benchmark was generated
     */
    'positionId': string;
    /**
     * Code of the position for which benchmark was generated
     */
    'positionCode': string;
    'status': GenerationStatus;
    'prompt': PromptData;
    'aiConfig': AIConfigData;
    'aiResponse'?: AIResponseData;
    'error'?: ErrorData;
    /**
     * Timestamp when generation was attempted
     */
    'generatedAt': string;
    /**
     * User who triggered the generation
     */
    'generatedBy'?: string;
}


/**
 * Request body for bulk benchmark generation with optional generation context and bulk operation targeting. Combines BulkOperationRequest (for targeting positions) with BenchmarkGenerationContext (for provider configs). 
 */
export interface BenchmarkGenerationRequest {
    [key: string]: any;

    /**
     * Optional array of specific entity IDs to target for the operation. If not provided or empty, targets all entities. 
     */
    'ids'?: Array<string>;
}
/**
 * Request body for bulk operations. - Omit \'ids\' or provide empty array to target all entities - Provide \'ids\' array with one or more IDs to target specific entities 
 */
export interface BulkOperationRequest {
    /**
     * Optional array of specific entity IDs to target for the operation. If not provided or empty, targets all entities. 
     */
    'ids'?: Array<string>;
}
/**
 * Error details for failed generations
 */
export interface ErrorData {
    /**
     * Exception type (class name)
     */
    'type': string;
    /**
     * Error message
     */
    'message': string;
    /**
     * Stack trace (may be truncated)
     */
    'stackTrace'?: string;
}
export interface ErrorEntry {
    'code'?: string;
    'message'?: string;
}
/**
 * Generic error envelope used across services
 */
export interface ErrorResponse {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
}
/**
 * Status of the benchmark generation attempt
 */

export const GenerationStatus = {
    Success: 'SUCCESS',
    Failed: 'FAILED'
} as const;

export type GenerationStatus = typeof GenerationStatus[keyof typeof GenerationStatus];


export interface OperationResult {
    /**
     * Number of items successfully processed
     */
    'successCount': number;
    /**
     * Total number of items targeted for processing
     */
    'totalCount': number;
    /**
     * Number of items that failed processing
     */
    'failedCount': number;
}
/**
 * Prompt data used for AI generation
 */
export interface PromptData {
    /**
     * ID of the prompt template used
     */
    'templateId'?: string;
    /**
     * Name of the prompt template used
     */
    'templateName'?: string;
    /**
     * System prompt sent to AI
     */
    'systemPrompt': string;
    /**
     * User prompt sent to AI (built from template and context)
     */
    'userPrompt': string;
    /**
     * Context data used for prompt building
     */
    'context'?: { [key: string]: any; };
}
export interface TaskCreateResponse {
    'taskId': string;
}

/**
 * BenchmarkApi - axios parameter creator
 */
export const BenchmarkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a benchmark
         * @param {string} id Unique identifier of the benchmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBenchmark: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBenchmark', 'id', id)
            const localVarPath = `/api/benchmarks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all benchmarks based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific benchmarks. Omit \'ids\' or provide empty array to delete all benchmarks (requires elevated permissions). 
         * @summary Delete benchmarks (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBenchmarksBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteBenchmarksBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/benchmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a benchmark for a position using generation providers. By default, all providers are used. AI provider requires explicit selection. 
         * @summary Generate benchmark for a specific position
         * @param {string} positionId Unique identifier of the position
         * @param {Array<string>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers are used.
         * @param {{ [key: string]: any; }} [requestBody] Optional provider-specific generation context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBenchmarkForPosition: async (positionId: string, providers?: Array<string>, requestBody?: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('generateBenchmarkForPosition', 'positionId', positionId)
            const localVarPath = `/api/benchmarks/generate/{positionId}`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providers) {
                localVarQueryParameter['providers'] = providers.join(COLLECTION_FORMATS.csv);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk generate benchmarks for positions using generation providers. By default, all providers are used. AI provider requires explicit selection. 
         * @summary Generate benchmarks (bulk operation, async)
         * @param {Array<string>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers are used.
         * @param {BenchmarkGenerationRequest} [benchmarkGenerationRequest] Optional bulk operation targeting and provider-specific generation context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBenchmarksBulk: async (providers?: Array<string>, benchmarkGenerationRequest?: BenchmarkGenerationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/benchmarks/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providers) {
                localVarQueryParameter['providers'] = providers.join(COLLECTION_FORMATS.csv);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(benchmarkGenerationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single benchmark by ID
         * @param {string} id Unique identifier of the benchmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenchmark: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBenchmark', 'id', id)
            const localVarPath = `/api/benchmarks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a benchmark associated with a position
         * @summary Get a benchmark for a specific position
         * @param {string} positionId Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenchmarkByPosition: async (positionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('getBenchmarkByPosition', 'positionId', positionId)
            const localVarPath = `/api/benchmarks/position/{positionId}`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all benchmarks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBenchmarks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/benchmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BenchmarkApi - functional programming interface
 */
export const BenchmarkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BenchmarkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a benchmark
         * @param {string} id Unique identifier of the benchmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBenchmark(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBenchmark(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BenchmarkApi.deleteBenchmark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all benchmarks based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific benchmarks. Omit \'ids\' or provide empty array to delete all benchmarks (requires elevated permissions). 
         * @summary Delete benchmarks (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBenchmarksBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBenchmarksBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BenchmarkApi.deleteBenchmarksBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a benchmark for a position using generation providers. By default, all providers are used. AI provider requires explicit selection. 
         * @summary Generate benchmark for a specific position
         * @param {string} positionId Unique identifier of the position
         * @param {Array<string>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers are used.
         * @param {{ [key: string]: any; }} [requestBody] Optional provider-specific generation context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBenchmarkForPosition(positionId: string, providers?: Array<string>, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Benchmark>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateBenchmarkForPosition(positionId, providers, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BenchmarkApi.generateBenchmarkForPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk generate benchmarks for positions using generation providers. By default, all providers are used. AI provider requires explicit selection. 
         * @summary Generate benchmarks (bulk operation, async)
         * @param {Array<string>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers are used.
         * @param {BenchmarkGenerationRequest} [benchmarkGenerationRequest] Optional bulk operation targeting and provider-specific generation context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBenchmarksBulk(providers?: Array<string>, benchmarkGenerationRequest?: BenchmarkGenerationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateBenchmarksBulk(providers, benchmarkGenerationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BenchmarkApi.generateBenchmarksBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single benchmark by ID
         * @param {string} id Unique identifier of the benchmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBenchmark(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Benchmark>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBenchmark(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BenchmarkApi.getBenchmark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a benchmark associated with a position
         * @summary Get a benchmark for a specific position
         * @param {string} positionId Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBenchmarkByPosition(positionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Benchmark>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBenchmarkByPosition(positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BenchmarkApi.getBenchmarkByPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all benchmarks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBenchmarks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Benchmark>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBenchmarks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BenchmarkApi.listBenchmarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BenchmarkApi - factory interface
 */
export const BenchmarkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BenchmarkApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a benchmark
         * @param {string} id Unique identifier of the benchmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBenchmark(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBenchmark(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all benchmarks based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific benchmarks. Omit \'ids\' or provide empty array to delete all benchmarks (requires elevated permissions). 
         * @summary Delete benchmarks (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBenchmarksBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteBenchmarksBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a benchmark for a position using generation providers. By default, all providers are used. AI provider requires explicit selection. 
         * @summary Generate benchmark for a specific position
         * @param {string} positionId Unique identifier of the position
         * @param {Array<string>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers are used.
         * @param {{ [key: string]: any; }} [requestBody] Optional provider-specific generation context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBenchmarkForPosition(positionId: string, providers?: Array<string>, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig): AxiosPromise<Benchmark> {
            return localVarFp.generateBenchmarkForPosition(positionId, providers, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk generate benchmarks for positions using generation providers. By default, all providers are used. AI provider requires explicit selection. 
         * @summary Generate benchmarks (bulk operation, async)
         * @param {Array<string>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers are used.
         * @param {BenchmarkGenerationRequest} [benchmarkGenerationRequest] Optional bulk operation targeting and provider-specific generation context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBenchmarksBulk(providers?: Array<string>, benchmarkGenerationRequest?: BenchmarkGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskCreateResponse> {
            return localVarFp.generateBenchmarksBulk(providers, benchmarkGenerationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single benchmark by ID
         * @param {string} id Unique identifier of the benchmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenchmark(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Benchmark> {
            return localVarFp.getBenchmark(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a benchmark associated with a position
         * @summary Get a benchmark for a specific position
         * @param {string} positionId Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenchmarkByPosition(positionId: string, options?: RawAxiosRequestConfig): AxiosPromise<Benchmark> {
            return localVarFp.getBenchmarkByPosition(positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all benchmarks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBenchmarks(options?: RawAxiosRequestConfig): AxiosPromise<Array<Benchmark>> {
            return localVarFp.listBenchmarks(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BenchmarkApi - object-oriented interface
 */
export class BenchmarkApi extends BaseAPI {
    /**
     * 
     * @summary Delete a benchmark
     * @param {string} id Unique identifier of the benchmark
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteBenchmark(id: string, options?: RawAxiosRequestConfig) {
        return BenchmarkApiFp(this.configuration).deleteBenchmark(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all benchmarks based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific benchmarks. Omit \'ids\' or provide empty array to delete all benchmarks (requires elevated permissions). 
     * @summary Delete benchmarks (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteBenchmarksBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return BenchmarkApiFp(this.configuration).deleteBenchmarksBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a benchmark for a position using generation providers. By default, all providers are used. AI provider requires explicit selection. 
     * @summary Generate benchmark for a specific position
     * @param {string} positionId Unique identifier of the position
     * @param {Array<string>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers are used.
     * @param {{ [key: string]: any; }} [requestBody] Optional provider-specific generation context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateBenchmarkForPosition(positionId: string, providers?: Array<string>, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig) {
        return BenchmarkApiFp(this.configuration).generateBenchmarkForPosition(positionId, providers, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk generate benchmarks for positions using generation providers. By default, all providers are used. AI provider requires explicit selection. 
     * @summary Generate benchmarks (bulk operation, async)
     * @param {Array<string>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers are used.
     * @param {BenchmarkGenerationRequest} [benchmarkGenerationRequest] Optional bulk operation targeting and provider-specific generation context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateBenchmarksBulk(providers?: Array<string>, benchmarkGenerationRequest?: BenchmarkGenerationRequest, options?: RawAxiosRequestConfig) {
        return BenchmarkApiFp(this.configuration).generateBenchmarksBulk(providers, benchmarkGenerationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single benchmark by ID
     * @param {string} id Unique identifier of the benchmark
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBenchmark(id: string, options?: RawAxiosRequestConfig) {
        return BenchmarkApiFp(this.configuration).getBenchmark(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a benchmark associated with a position
     * @summary Get a benchmark for a specific position
     * @param {string} positionId Unique identifier of the position
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBenchmarkByPosition(positionId: string, options?: RawAxiosRequestConfig) {
        return BenchmarkApiFp(this.configuration).getBenchmarkByPosition(positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all benchmarks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listBenchmarks(options?: RawAxiosRequestConfig) {
        return BenchmarkApiFp(this.configuration).listBenchmarks(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BenchmarkGenerationLogsApi - axios parameter creator
 */
export const BenchmarkGenerationLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all benchmark generation logs for a specific position, ordered by generation time descending (newest first). Logs include prompts, AI configuration, responses, and errors for debugging and audit purposes. 
         * @summary Get benchmark generation logs for a position
         * @param {string} positionCode Position code to query generation logs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenchmarkGenerationLogsByPositionCode: async (positionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionCode' is not null or undefined
            assertParamExists('getBenchmarkGenerationLogsByPositionCode', 'positionCode', positionCode)
            const localVarPath = `/api/benchmarks/generation-logs/position/{positionCode}`
                .replace(`{${"positionCode"}}`, encodeURIComponent(String(positionCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BenchmarkGenerationLogsApi - functional programming interface
 */
export const BenchmarkGenerationLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BenchmarkGenerationLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all benchmark generation logs for a specific position, ordered by generation time descending (newest first). Logs include prompts, AI configuration, responses, and errors for debugging and audit purposes. 
         * @summary Get benchmark generation logs for a position
         * @param {string} positionCode Position code to query generation logs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBenchmarkGenerationLogsByPositionCode(positionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BenchmarkGenerationLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBenchmarkGenerationLogsByPositionCode(positionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BenchmarkGenerationLogsApi.getBenchmarkGenerationLogsByPositionCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BenchmarkGenerationLogsApi - factory interface
 */
export const BenchmarkGenerationLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BenchmarkGenerationLogsApiFp(configuration)
    return {
        /**
         * Retrieve all benchmark generation logs for a specific position, ordered by generation time descending (newest first). Logs include prompts, AI configuration, responses, and errors for debugging and audit purposes. 
         * @summary Get benchmark generation logs for a position
         * @param {string} positionCode Position code to query generation logs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenchmarkGenerationLogsByPositionCode(positionCode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BenchmarkGenerationLog>> {
            return localVarFp.getBenchmarkGenerationLogsByPositionCode(positionCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BenchmarkGenerationLogsApi - object-oriented interface
 */
export class BenchmarkGenerationLogsApi extends BaseAPI {
    /**
     * Retrieve all benchmark generation logs for a specific position, ordered by generation time descending (newest first). Logs include prompts, AI configuration, responses, and errors for debugging and audit purposes. 
     * @summary Get benchmark generation logs for a position
     * @param {string} positionCode Position code to query generation logs for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBenchmarkGenerationLogsByPositionCode(positionCode: string, options?: RawAxiosRequestConfig) {
        return BenchmarkGenerationLogsApiFp(this.configuration).getBenchmarkGenerationLogsByPositionCode(positionCode, options).then((request) => request(this.axios, this.basePath));
    }
}



